function createToast(setToasts, ttlMs = 4200) {
  return (kind, title, desc) => {
    const id = Date.now() + Math.random();
    setToasts((curr) => [...curr, { id, kind, title, desc }]);
    setTimeout(() => {
      setToasts((curr) => curr.filter((x) => x.id !== id));
    }, ttlMs);
  };
}

export { createToast };
